import React from "react";
import beacon from "../../api/logClick.js";

/**
 * This component is a div.  It appears in the modal and shows all
 * the child links, positioned below the parent picture.
 *
 */
const APP_DOMAIN = `https://${process.env.REACT_APP_DOMAIN}`;

const ImageLinksDiv = ({ imageLinksData }) => {
  return (
    <div className="image-links-grid">
      {imageLinksData.data.map((imageLink, index) => {
        const thumbnailUrl = imageLink.imageUrl.replace(
          /^https:\/\/[^/]+/,
          APP_DOMAIN
        );

        console.log("Original:", imageLink.imageUrl, "Rewritten:", thumbnailUrl);

        return (
          <a
            key={index}
            href={imageLink.linkUrl}
            target="_self"
            onClick={() => beacon(imageLink.id, "placeholder", imageLink.linkUrl)}
          >
            <img src={thumbnailUrl} alt={thumbnailUrl} />
          </a>
        );
      })}
    </div>
  );
};

export default ImageLinksDiv;
